import { getCloudStorageItem } from "@tradingApp/helpers/cloudStorage";
import {
  I18N_LOCALE_DEFAULT,
  I18N_LOCALE_STORAGE_KEY,
  I18N_LOCALES,
} from "@tradingApp/Providers/I18nProvider/constants";
import type { I18nLocale } from "@tradingApp/Providers/I18nProvider/types";
import WebApp from "@twa-dev/sdk";

export async function i18nUserLocaleGet(): Promise<I18nLocale> {
  const storageLocale = await getCloudStorageItem(I18N_LOCALE_STORAGE_KEY);
  const userLocale = WebApp.initDataUnsafe?.user?.language_code as I18nLocale;
  const foundLocale = (storageLocale as I18nLocale) ?? userLocale;
  const isLocaleValid = I18N_LOCALES.includes(foundLocale);

  return isLocaleValid ? foundLocale : I18N_LOCALE_DEFAULT;
}
